export default "__VITE_ASSET__0ws6dHr5__"